module.exports = __webpack_public_path__ + "static/img/input.fd627960.svg";